import React from "react";

export default function Training() {
  return (
    <div className="h-4/5 flex align-middle justify-center items-center">
      <h1 className="text-center text-2xl font-bold">
        La page Training n'est pas encore disponible
      </h1>
    </div>
  );
}
